import NotificationTypeEnum from '../../../../../Spirit/Entities/Enums/NotificationTypeEnum';
import NotificationTranslationsRequest from '../../../../../Spirit/Admin/Interfaces/Models/NotificationService/NotificationTranslationsRequest';

export default class NotificationUpdateRequest  {
	NotificationId: number = 0;
	NotificationType: NotificationTypeEnum = null;
	Name?: string = '';
	Translations: Array<NotificationTranslationsRequest> = null;
	constructor(obj?: Partial<NotificationUpdateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
